import { useFormikContext } from "formik";
import { FC, useEffect, useRef } from "react";

import { parseBirthDateFromPesel } from "web/utils/parseBirthDateFromPesel";

import {
  ISubscriptionReceiverFormField,
  ISubscriptionReceiverFormValues,
  SubscriptionActiveFormFieldType,
} from "web/types/Subscription";

export interface PeselBirthDatePair {
  peselFieldId: string;
  birthDateFieldId: string;
}

export const getPeselBirthDatePairs = (
  fields: ISubscriptionReceiverFormField[]
): PeselBirthDatePair[] => {
  const peselFields = fields.filter(
    (f) => f.type === SubscriptionActiveFormFieldType.PESEL
  );
  const birthDateFields = fields.filter(
    (f) => f.type === SubscriptionActiveFormFieldType.BIRTHDATE
  );

  const pairs: PeselBirthDatePair[] = [];

  peselFields.forEach((peselField) => {
    birthDateFields.forEach((birthDateField) => {
      const isLinked =
        (!!peselField.requiredWhenFilled &&
          peselField.requiredWhenFilled ===
            birthDateField.requiredWhenFilled) ||
        peselField.requiredWhenFilled === birthDateField.id ||
        birthDateField.requiredWhenFilled === peselField.id;

      if (isLinked) {
        pairs.push({
          peselFieldId: peselField.id,
          birthDateFieldId: birthDateField.id,
        });
      }
    });
  });

  return pairs;
};

export const PeselBirthDateAutoFillEffect: FC<{
  pairs: PeselBirthDatePair[];
}> = ({ pairs }) => {
  const { values, setFieldValue } =
    useFormikContext<ISubscriptionReceiverFormValues>();
  const prevPeselValues = useRef<Record<string, string>>({});

  useEffect(() => {
    pairs.forEach(({ peselFieldId, birthDateFieldId }) => {
      const peselValue = (values[peselFieldId] as string) || "";
      const prevPesel = prevPeselValues.current[peselFieldId] ?? "";

      if (peselValue === prevPesel) return;

      prevPeselValues.current[peselFieldId] = peselValue;

      if (peselValue) {
        const birthDateTimestamp = parseBirthDateFromPesel(peselValue);
        if (birthDateTimestamp !== null) {
          setFieldValue(birthDateFieldId, birthDateTimestamp);
        }
      } else {
        setFieldValue(birthDateFieldId, null);
      }
    });
  }, [values, pairs, setFieldValue]);

  return null;
};
